var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.615,
    height: 32.615,
    viewBox: "0 0 32.615 32.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668",
    transform: "translate(-394 -336)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 16.307,
    cy: 16.307,
    r: 16.307,
    transform: "translate(394 336)",
    fill: "#14d4e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(698.721 989.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M-288.8-629.432c-.279-.038-.56-.062-.836-.115a7.277,7.277,0,0,1-5.222-3.8,6.883,6.883,0,0,1-.86-3.614,7.221,7.221,0,0,1,2.72-5.524,7.092,7.092,0,0,1,3.89-1.616c.459-.047.925-.037,1.4-.054l-.15,1.488a5.916,5.916,0,0,0-5.162,2.207,5.6,5.6,0,0,0-1.285,4.144,5.891,5.891,0,0,0,5.864,5.412,5.721,5.721,0,0,0,4.367-1.967,5.923,5.923,0,0,0,1.5-4.573l1.481-.15.078.349v.891c-.012.1-.024.207-.035.31a7.251,7.251,0,0,1-1.582,3.841,7.251,7.251,0,0,1-4.485,2.659c-.272.049-.547.076-.821.113Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M-24.531-642.9l-2.621,2.637h1.873v1.465h-4.386v-4.391h1.453v1.9l2.647-2.649c.314.315.614.615.915.915a1.445,1.445,0,0,0,.119.1Z",
    transform: "translate(-256.481 -0.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M-110.459-558.474h2.192V-557h-.158c-1.115,0-2.23,0-3.345,0-.132,0-.168-.035-.167-.167q.007-2.412,0-4.823c0-.132.035-.17.168-.167.383.009.766.009,1.148,0,.138,0,.165.044.164.171,0,1.105,0,2.211,0,3.316Z",
    transform: "translate(-177.171 -79.049)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0cb1cab98d1fcccd8453653850562b31.svg";
export { ForwardRef as ReactComponent };